"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vectorizedDatasheetChunk = exports.vectorizedDatasheetChunkMetadata = void 0;
const zod_1 = require("zod");
exports.vectorizedDatasheetChunkMetadata = zod_1.z.object({
    pageStart: zod_1.z.number(),
    pageEnd: zod_1.z.number(),
    lineStart: zod_1.z.number(),
    lineEnd: zod_1.z.number(),
    text: zod_1.z.string(),
});
exports.vectorizedDatasheetChunk = zod_1.z.object({
    id: zod_1.z.string(),
    values: zod_1.z.array(zod_1.z.number()),
    metadata: exports.vectorizedDatasheetChunkMetadata,
});
//# sourceMappingURL=datasheet.js.map